module.exports = require("wix-storage-frontend");